export default "__VITE_ASSET__DoIKfsTQ__"